export enum LinkType {
  NOT_MY_RECEIPT = 'NOT_MY_RECEIPT',
  RENABLE_PROFILE = 'RENABLE_PROFILE',
  REMOVE_PROFILE = 'REMOVE_PROFILE',
}
